import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGenderFemale: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGenderFemale"><Path fillRule="evenodd" clipRule="evenodd" d="M12 3.5C9.23858 3.5 7 5.73858 7 8.5C7 11.2614 9.23858 13.5 12 13.5C14.7614 13.5 17 11.2614 17 8.5C17 5.73858 14.7614 3.5 12 3.5ZM5.5 8.5C5.5 4.91015 8.41015 2 12 2C15.5899 2 18.5 4.91015 18.5 8.5C18.5 11.8362 15.9866 14.5853 12.75 14.9572V17.5H16V19H12.75V22H11.25V19H8V17.5H11.25V14.9572C8.01342 14.5853 5.5 11.8362 5.5 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGenderFemale;
